import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface NotificacaoEnviadaItem {
    id: number
    titulo: string
    mensagem: string
    tipo: string
    quantidade: number
    dataInicio: string | null
}

export interface NotificacaoAgendadaItem {
    id: number
    titulo: string
    mensagem: string
    quantidade: number
    dataInicio: string | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    ) {
        const d = data as RespostaErroRaw
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterNotificacoesAgendadas = async function (
    authorization: string
): Promise<NotificacaoAgendadaItem[] | ErroApi> {
    try {
        const response = await api
            .get<NotificacaoAgendadaItem[] | RespostaErroRaw>(
                "estrategias/ObterNotificacoesAgendadas",
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as NotificacaoAgendadaItem[]
    } catch (error) {
        RegistrarLogErro(error, "ObterNotificacoesAgendadas", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

const datePattern = /^\d{4}-\d{2}-\d{2}$/

export const obterNotificacoesEnviadas = async function (
    authorization: string,
    dataInicio: string,
    dataFim: string,
    titulo: string
): Promise<NotificacaoEnviadaItem[] | ErroApi> {
    if (!datePattern.test(dataInicio) || !datePattern.test(dataFim)) {
        return { retornoErro: 1, mensagem: "Datas inválidas: formato esperado yyyy-MM-dd" }
    }
    try {
        const params = new URLSearchParams({ dataInicio, dataFim })
        if (titulo) params.append("titulo", titulo)

        const response = await api
            .get<NotificacaoEnviadaItem[] | RespostaErroRaw>(
                `estrategias/ObterNotificacoesEnviadas?${params.toString()}`,
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as NotificacaoEnviadaItem[]
    } catch (error) {
        RegistrarLogErro(error, "ObterNotificacoesEnviadas", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const excluirNotificacao = async function (
    authorization: string,
    id: number
): Promise<void | ErroApi> {
    try {
        const response = await api
            .delete<RespostaErroRaw | null>(`estrategias/ExcluirNotificacao/${id}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        if (response.data && isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
    } catch (error) {
        RegistrarLogErro(error, "ExcluirNotificacao", String(id))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
